import {Item} from './Item'

export const TrustBlock = () => {
  return (
    <div className="rounded-lg flex flex-col gap-4">
      <div className="font-bold text-[18px]">Book with confidence</div>
      <Item title="Local experts" description="Personal stories and insider travel tips" />
      <Item title="Top-rated" description="Thousands of reviews averaging 4.9 stars" />
      <Item title="Worry-free booking" description="Flexible scheduling and refunds" />
    </div>
  )
}
